/**
 * Lot ORG 0.5.x (vague 4) — profil de l'organisation COURANTE (`GET /org-profile`), partagé par la
 * barre de contexte (le NOM de l'organisation, lien vers sa fiche) et la fiche « Mon organisation ».
 * Une seule clé de cache : renommer l'organisation met la barre à jour aussitôt.
 */
import { useQuery, type UseQueryResult } from '@tanstack/react-query'

import { CLE_PROFIL_ORGANISATION, organisationFicheApi, type ProfilOrganisation } from '@/api/organisationFicheApi'

export function useProfilOrganisation(organisationId: string | null | undefined): UseQueryResult<ProfilOrganisation> {
  return useQuery({
    queryKey: CLE_PROFIL_ORGANISATION,
    queryFn: organisationFicheApi.profil,
    enabled: Boolean(organisationId),
    retry: false,
    staleTime: 60_000,
  })
}

/** Nom lisible de l'organisation courante ; l'identifiant technique tant qu'il n'est pas lu. */
export function useNomOrganisation(organisationId: string | null | undefined): string | null {
  const profil = useProfilOrganisation(organisationId)
  return profil.data?.organisation.name ?? organisationId ?? null
}
